@if (initForm) {
  <form class="conf-order-form" [formGroup]="confirmOrderForm" (ngSubmit)="onSubmit()">
    <div class="conf-order-form__fields">
      <!-- Email -->
      <div class="conf-order-form__field">
        <bmcore-input-b
          themeInputClass="theme-input__counterInput"
          themeInputPlaceholderClass="theme-input__counterInput-placeholder"
          formControlName="email"
          [title]="lg.forms.email"
          [initialValue]="clientData?.email"
          [type]="'email'"
          [controlFormName]="'email'"
          [tag]="'input'"
        >
        </bmcore-input-b>
      </div>
      <!-- Full name -->
      <div class="conf-order-form__field">
        <bmcore-input-b
          themeInputClass="theme-input__counterInput"
          themeInputPlaceholderClass="theme-input__counterInput-placeholder"
          formControlName="fullName"
          [title]="lg.forms.fullName"
          [initialValue]="clientData?.fullName[lang]"
          [type]="'text'"
          [controlFormName]="'fullName'"
          [tag]="'input'"
        >
        </bmcore-input-b>
      </div>
      <!--RU Passport  / EN Address -->
      @if (group.hasRequiredPassportLicense) {
        <div class="conf-order-form__field">
          <bmcore-input-b
            themeInputClass="theme-input__counterInput"
            themeInputPlaceholderClass="theme-input__counterInput-placeholder"
            formControlName="passport"
            [title]="lang === 'ru' ? 'Паспортные данные*' : 'Address*'"
            [initialValue]="clientData?.passportData[lang]"
            [type]="'text'"
            [controlFormName]="'passportAddressData'"
            [tag]="'textarea'"
          >
          </bmcore-input-b>
          <!-- Tooltip -->
          <bmcore-tooltip [lang]="lang"></bmcore-tooltip>
        </div>
      }
      <!--Payment-->
      @if (lang === 'en') {
        <div class="payment__box">
          <div class="btv-icon-paypal theme-icon__counter__payPalEn"></div>
          <!-- Total price with cashback -->
          <p class="theme-popUp__confirm-price">
            {{ lg.confirmationOrderPopup.total }} : {{ group.priceWithDiscount - group.cashbackAmount }}
            {{ currencySign }}
          </p>
        </div>
      }
      @if (lang === 'ru') {
        <div class="conf-order-form__field conf-order-form__field--select">
          <mat-form-field appearance="outline" bmTheme="confirm-popup-select">
            <mat-label>{{ lg.confirmationOrderPopup.paymentSystem }}</mat-label>
            <mat-select [(value)]="paymentType" (selectionChange)="changePayment($event)">
              @for (p of payments; track p) {
                <mat-option [value]="p.type">
                  {{ p.title }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <!-- Field QIWI Phone -->
      @if (isPhoneField) {
        <div class="conf-order-form__field">
          <bmcore-input-b
            themeInputClass="theme-input__counterInput"
            themeInputPlaceholderClass="theme-input__counterInput-placeholder"
            formControlName="phone"
            [title]="'Введите номер Qiwi-кошелька. Формат: +79845654655'"
            [initialValue]="''"
            [type]="'text'"
            [controlFormName]="'phone'"
            [tag]="'input'"
          >
          </bmcore-input-b>
        </div>
      }
    </div>
    <!-- Total price with cashback -->
    @if (lang === 'ru') {
      <p class="conf-order-form__price theme-popUp__confirm-price">
        {{ lg.confirmationOrderPopup.total }}
        : {{ group.priceWithDiscount - group.cashbackAmount }} {{ currencySign }}
      </p>
    }
    <div class="conf-order-form__btn">
      <bmcore-button
        themeBtnClass="theme-btn__counter-btnBuy"
        themeIconClass="theme-icon__counter-btnBuy"
        title="{{ lg.button.payPurchase }}"
        icon="btv-icon-cart"
        [disabled]="paymentPageLoading"
      >
      </bmcore-button>
    </div>
  </form>
}
